import { NRAttributes } from './NewRelicEvents'

export class NewRelicManager {
  static instance: NewRelicManager | null
  private readonly tenant: string | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private readonly newRelic: any

  private constructor(tenant: string) {
    this.tenant = tenant
    this.newRelic = window['NREUM']
    this.setTenantName()
  }

  static getInstance(tenant: string): NewRelicManager {
    if (!NewRelicManager.instance) {
      NewRelicManager.instance = new NewRelicManager(tenant)
    }
    return NewRelicManager.instance
  }

  private canLogEvent(): boolean {
    return Boolean(this.newRelic) && Boolean(this.tenant)
  }

  public addPageAction(actionName: string, customAttributes: Record<string, unknown> = {}): void {
    this.canLogEvent() && this.newRelic?.addPageAction(actionName, customAttributes)
  }

  public setCustomAttribute(key: string, value: string | number | null): void {
    this.newRelic?.setCustomAttribute(key, value)
  }

  private setTenantName(): void {
    this.setCustomAttribute(NRAttributes.TENANT_NAME, this.tenant)
  }
}
